import httpService from './http.service';

const nintendoDealsService = {
  // Получение данных о скидках Nintendo из CSV файлов
  getDeals: async (region = 'pl', page = 1, pageSize = 16) => {
    try {
      // Загружаем CSV файл в зависимости от региона
      const csvFile = region === 'us' ? 'deku_hottest_deals_us.csv' : 'deku_hottest_deals_pl.csv';
      const response = await fetch(`/deals/${csvFile}`);
      const csvText = await response.text();
      
      // Парсим CSV с учетом возможных запятых в ценах
      const lines = csvText.split('\n');
      const headers = lines[0].split(',');
      const data = lines.slice(1).filter(line => line.trim()).map(line => {
        // Используем более надежный парсинг CSV
        const values = [];
        let current = '';
        let inQuotes = false;
        
        for (let i = 0; i < line.length; i++) {
          const char = line[i];
          if (char === '"') {
            inQuotes = !inQuotes;
          } else if (char === ',' && !inQuotes) {
            values.push(current.trim());
            current = '';
          } else {
            current += char;
          }
        }
        values.push(current.trim());
        
        const obj = {};
        headers.forEach((header, index) => {
          obj[header.trim()] = values[index] ? values[index].trim() : '';
        });
        return obj;
      });

      // Пагинация
      const startIndex = (page - 1) * pageSize;
      const endIndex = startIndex + pageSize;
      const paginatedData = data.slice(startIndex, endIndex);

      return {
        results: paginatedData,
        count: data.length,
        currentPage: page,
        pageSize: pageSize,
        totalPages: Math.ceil(data.length / pageSize)
      };
    } catch (error) {
      console.error('Error loading Nintendo deals:', error);
      throw error;
    }
  },

  // Получение всех данных без пагинации
  getAllDeals: async (region = 'pl') => {
    try {
      const csvFile = region === 'us' ? 'deku_hottest_deals_us.csv' : 'deku_hottest_deals_pl.csv';
      const response = await fetch(`/deals/${csvFile}`);
      const csvText = await response.text();
      
      const lines = csvText.split('\n');
      const headers = lines[0].split(',');
      const data = lines.slice(1).filter(line => line.trim()).map(line => {
        // Используем более надежный парсинг CSV
        const values = [];
        let current = '';
        let inQuotes = false;
        
        for (let i = 0; i < line.length; i++) {
          const char = line[i];
          if (char === '"') {
            inQuotes = !inQuotes;
          } else if (char === ',' && !inQuotes) {
            values.push(current.trim());
            current = '';
          } else {
            current += char;
          }
        }
        values.push(current.trim());
        
        const obj = {};
        headers.forEach((header, index) => {
          obj[header.trim()] = values[index] ? values[index].trim() : '';
        });
        return obj;
      });

      return data;
    } catch (error) {
      console.error('Error loading all Nintendo deals:', error);
      throw error;
    }
  }
};

export default nintendoDealsService; 